import { grey } from '@material-ui/core/colors';
import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
	sectionContainer: {
		paddingTop: 0,
		paddingBottom: 20,
		paddingLeft: 40,
		paddingRight: 40,
		[theme.breakpoints.down('md')]: {
			paddingLeft: 30,
			paddingRight: 30
		}
	},
	titleContainer: {
		marginBottom: 20,
		display: 'flex',
		alignItems: 'center'
	},
	buttonContainer: {
		position: 'absolute',
		marginLeft: 'auto',
		display: 'flex',
		right: 60,
		[theme.breakpoints.down('md')]: {
			right: 30
		}
	},
	navButton: {
		background: '#3F3F3F',
		width: 32,
		height: 32,
		margin: 2,
		border: 0,
		color: 'white',
		borderRadius: 4,
		display: 'flex',
		alignItems: 'center',
		cursor: 'pointer'
	},
	title: {
		fontSize: 16,
		fontWeight: 500,
		lineHeight: '22px',
		color: grey[900]
	},
	contactContainer: {
		display: 'flex',
		flexDirection: 'row',
		width: '100%'
	},
	slider: {
		position: 'relative',
		width: '100%',
		height: '100%'
	}
}));
